.input {
  border-color: #ececed;
  border-radius: 4px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 400;

  &::placeholder {
    color: rgb(117 117 117 / 50%);
  }

  &[data-error] {
    background-color: #fdeded;
    border-color: #f34f52;
  }
}

.dropdown {
  box-shadow: lch(0% 0 0deg / 2%) 0 6px 18px,
  lch(0% 0 0deg / 4%) 0 3px 9px,
  lch(0% 0 0deg / 4%) 0 1px 1px;
}

  /* Custom label font size */
.label {
  color: #0f172a;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 7px;
}

.option {
  color: #0f172a;
  font-size: 13px;

  &:hover {
    background-color: #ffeaf7;
  }

  &[data-checked='true'] {
    > :last-child {
      color: var(--velos-brand-pink);
    }
  }
}

.pill {
  background-color: #ffeaf7;
  font-size: 12px;
  font-weight: 500;
  gap: 5px;
  height: 100%;
  margin-bottom: -2px;
  margin-top: -2px;
  padding: 2px 3px 2px 12px;
}
